import React from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import { faSearch, faTags } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ButtonComponent from '@component/Form/Button'
import DateComponent from '@component/Form/Date'

import { OmbudsmanManifestationService } from '@service/ombudsman/manifestations'

import Swal from 'sweetalert2'

var date = new Date();
var startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
var endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);


export default function OmbudsmanDashboard() {

    const navigate = useNavigate();

    const [items, setItems] = React.useState([]);

    const filterButtonRef = React.useRef(null);

    const { 
        control, 
        formState: { errors }, 
        handleSubmit, 
        register 
    } = useForm({ mode: 'onChange' })


    const onSubmit = async (data, e) => {
        e.preventDefault();

        Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            imageUrl: '/assets/images/loading.gif',
            imageWidth: 100,
            imageHeight: 100,
            text: 'Processando, aguarde...',
            showConfirmButton: false,
            width: 300,
        });
        
        await OmbudsmanManifestationService.dashboard(data)
            .then(response => {
                setItems(response.data);
                Swal.close();
            })
            .catch(error => { 
                Swal.close();
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    icon: 'error',
                    text: error
                });
            });
    }

    React.useEffect(() => {
        const buttonElement = document.getElementById('btn-filter');
        if (buttonElement) { buttonElement.click(); }
    }, []);


    return (
        <>

            <div className='header'>
                <h1 className='header-title'>Ouvidoria</h1>
                <p className='header-subtitle'>Dashboard do módulo de ouvidoria</p>
            </div>

            <Row className='mb-3'>
                <Col sm={3}>
                    <Card>
                        <Card.Body>
                            <Row>
                                <Col className='mt-0'>
                                    <Card.Title>Período</Card.Title>
                                </Col>
                            </Row>

                            <Form 
                                autoComplete='off'
                                noValidate
                                onSubmit={handleSubmit(onSubmit)}>

                                    <Row>
                                        <Col lg={5}>
                                            <DateComponent
                                                control={control}
                                                errors={errors}
                                                name='date_ini'
                                                placeholder='00/00/0000'
                                                register={register}
                                                required={true}
                                                defaultValue={startOfMonth}
                                            />
                                        </Col>

                                        <Col lg={5}>
                                            <DateComponent
                                                control={control}
                                                errors={errors}
                                                name='date_end'
                                                register={register}
                                                required={true}
                                                defaultValue={endOfMonth}
                                            />
                                        </Col>

                                        <Col lg={2}>
                                            <ButtonComponent
                                                variant=''
                                                icon={ faSearch }
                                                title=''
                                                id='btn-filter'
                                                size='md'
                                                ref={filterButtonRef}
                                            />
                                        </Col>
                                    </Row>

                            </Form>
                        </Card.Body>
                    </Card>
                </Col>

                {
                    (items) ? (
                        items.map(item => (
                            <Col sm={3}>
                                <Card>
                                    <Card.Body>
                                        <Row>
                                            <Col className='mt-0'>
                                                <Card.Title>{item.title}</Card.Title>
                                            </Col>
                                            
                                            <div className="col-auto">
                                                <div className="avatar">
                                                    <div className={`avatar-title rounded-circle ${item.class}`}>
                                                        <FontAwesomeIcon icon={faTags} />
                                                    </div>
                                                </div>
                                            </div>
                                        </Row>
                                        <h1 className="display-5 mt-1 mb-3">{item.count}</h1>
                                        <p className="text-muted">{item.description}</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))                        
                    ) : ''
                }
            </Row>

        </>
    )
}
